import type { RecommendationsQuery } from '@algolia/recommend'

// 14kb min vs this:
export function algoliarecommend(requests: RecommendationsQuery[]) {
    const { VITE_ALGOLIA_APP_ID: appId, VITE_ALGOLIA_API_KEY: apiKey } = import.meta.env

    const url = `https://${appId}-dsn.algolia.net/1/indexes/*/recommendations`

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Algolia-Application-Id': appId,
            'X-Algolia-API-Key': apiKey
        },
        body: JSON.stringify({
            requests
        })
    })
}